<!-- Not mat-dialog-title: the shared surface style in styles.scss gives every
     dialog a fixed inline padding, and a header that carries an icon block
     needs to own its own spacing and its own rule under it. -->
<header class="dialog-head">
  <span class="dialog-head-icon" aria-hidden="true"><mat-icon>folder_managed</mat-icon></span>
  <div class="dialog-head-text">
    <h2 class="dialog-title">Manage projects</h2>
    <p class="dialog-subtitle">
      Each project is a separate agent with its own knowledge, settings and widget.
      Deactivating one hides it from the switcher without deleting anything.
    </p>
  </div>
</header>

<mat-dialog-content class="dialog-body">
  <ul class="project-list">
    <li class="project-row" *ngFor="let p of projectContext.projects$ | async; trackBy: trackById"
        [class.is-inactive]="!p.isActive">
      <nubo-avatar [name]="p.name" size="md"></nubo-avatar>

      <span class="project-text">
        <span class="project-name">{{ p.name }}</span>
        <span class="project-meta">
          <nubo-badge *ngIf="p.isDefault" tone="brand">Default</nubo-badge>
          <nubo-badge *ngIf="!p.isActive" tone="neutral">Hidden</nubo-badge>
        </span>
      </span>

      <span class="row-actions">
        <button mat-icon-button class="row-action" (click)="rename(p)"
                aria-label="Rename project" matTooltip="Rename">
          <mat-icon>edit</mat-icon>
        </button>

        <!-- The default project is the tenant's original one and cannot be hidden. -->
        <button mat-icon-button class="row-action" *ngIf="!p.isDefault" (click)="toggle(p)"
                [attr.aria-label]="p.isActive ? 'Hide project from the switcher' : 'Show project in the switcher'"
                [matTooltip]="p.isActive ? 'Hide from the switcher' : 'Show in the switcher'">
          <mat-icon>{{ p.isActive ? 'visibility' : 'visibility_off' }}</mat-icon>
        </button>
      </span>
    </li>
  </ul>
</mat-dialog-content>

<mat-dialog-actions class="dialog-foot" align="end">
  <button mat-flat-button color="primary" mat-dialog-close>Done</button>
</mat-dialog-actions>
